import { useCallback, useEffect, useMemo } from 'react';

import type {
  IUserFingerprintData,
  UserFingerprintDataInstanceType,
} from 'services/FingerprintService/fingerprint.model';

import { getUserData } from '../helpers/getUserData';

interface IUseCollectUserData {
  handleUserDataEffect: (data: IUserFingerprintData) => void;
  instance_id: string;
  instance_type: UserFingerprintDataInstanceType;
  conditions?: boolean[];
}

export const useCollectUserData = ({
  instance_id,
  instance_type,
  conditions = [],
  handleUserDataEffect,
}: IUseCollectUserData) => {
  const mainCondition = useMemo(() => conditions.every(Boolean) && instance_id, [conditions, instance_id]);

  const collectUserData = useCallback(async () => await getUserData({ instance_id, instance_type }), [mainCondition]);

  useEffect(() => {
    mainCondition &&
      collectUserData().then((data) => {
        handleUserDataEffect(data);
      });
  }, [mainCondition]);
};
